import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { CoreService } from "../services";


@Injectable()
export class QuestionnaireService {


  constructor(private indParam: CoreService,) {
   this.availableQuestionnaire = indParam.AppParams.UrlQuestionnaireWS ? true : false;
  }

  //check if questionnaire api is available
  public availableQuestionnaire = false;

  private data = new BehaviorSubject<any>(null);

  setNavigationData(data: any) {
    this.data.next(data);
  }

  getNavigationData() {
    return this.data.asObservable();
  }
}
